'use client';

import { useQuery } from '@tanstack/react-query';

import { getSpaceLanguagesService, getUserAddonsService, getVoicesService } from '@/services/httpServices/GeneralServices';
import type { GetSpaceLanguagesServiceConfig, GetUserAddonsServiceConfig, GetVoicesServiceConfig } from '@/services/httpServices/GeneralServices/types';

import { useQueryConfig } from './useQueryConfig';
import { spaceLanguagesKeys, userAddonsKeys, voicesKeys } from './userAddonsQueryKeys';

export function useUserAddonsQuery(config: GetUserAddonsServiceConfig) {
  const { isEnabled } = useQueryConfig();

  return useQuery({
    queryKey: userAddonsKeys(config),
    queryFn: async () => getUserAddonsService(config),
    enabled: isEnabled,
  });
}

export function useSpaceLanguagesQuery(config: GetSpaceLanguagesServiceConfig) {
  const { isEnabled } = useQueryConfig();

  return useQuery({
    queryKey: spaceLanguagesKeys(config),
    queryFn: async () => getSpaceLanguagesService(config),
    enabled: isEnabled,
  });
}

export function useVoicesQuery(config: GetVoicesServiceConfig, enabled = true) {
  const { isEnabled } = useQueryConfig();

  return useQuery({
    queryKey: voicesKeys(config),
    queryFn: async () => getVoicesService(config),
    enabled: isEnabled && enabled,
  });
}
